import { DateTimeFilterConfig } from '../types/filter-config';
import { formatDate, IsoDateTime, QueryFilter } from '@softline/core';
import { FilterItemConfigOptions } from '../types/filter-item-config-options';
import { FilterStateFactoryRef } from './filter.function';
import { DateTimeFilter } from '../types/filter';
import { DateFilterOperator } from '../types/filter-operators';
import { defaultFilterInputTypeFactory } from '../page-filter/helper/default-filter-input-type.factory';

export interface DateTimeFilterOptions<T extends object> extends FilterItemConfigOptions<T, IsoDateTime> {
  defaultOperator?: DateFilterOperator;
  allowedOperators?: DateFilterOperator[];
}

export function dateTimeFilter<T extends object>(
  ref: FilterStateFactoryRef<T>,
  options: DateTimeFilterOptions<T>): void {
  ref.addItem({
    ...options,
    type: 'dateTime',
    defaultOperator: options?.defaultOperator ?? 'equals',
    allowedOperators: options.allowedOperators ?? ['equals', 'notEquals', 'before', 'after', 'beforeOrEquals', 'afterOrEquals', 'in', 'notIn', 'between', 'empty', 'notEmpty'],
    formatter: options.formatter ?? ((o) => formatDate(o)),
    toQueryFilter,
    inputTypeFactory: defaultFilterInputTypeFactory,
  } as DateTimeFilterConfig<T>);
}

function toQueryFilter<T extends object>(value: DateTimeFilter<T>): QueryFilter<T> {
  switch (value.operator) {
    case 'empty':
      return { name: value.field, type: 'dateEmpty' }
    case 'notEmpty':
      return { name: value.field, type: 'dateNotEmpty' }
    case 'equals':
      return { name: value.field, type: 'dateEquals', value: value.value }
    case 'notEquals':
      return { name: value.field, type: 'dateNotEquals', value: value.value }
    case 'before':
      return { name: value.field, type: 'dateBefore', value: value.value }
    case 'after':
      return { name: value.field, type: 'dateAfter', value: value.value }
    case 'beforeOrEquals':
      return { name: value.field, type: 'dateBeforeOrEquals', value: value.value }
    case 'afterOrEquals':
      return { name: value.field, type: 'dateAfterOrEquals', value: value.value }
    case 'between':
      return { name: value.field, type: 'dateInRange', valueFrom: value.value.from, valueTo: value.value.to }
    case 'in':
      throw new Error('operator in not supported yet by the api');
    case 'notIn':
      throw new Error('operator notIn not supported yet by the api');
  }
}
